/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_Paid_OutInputs */

const en_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Paid Out`)
};

const es_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total pagado`)
};

const fr_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total payé`)
};

const de_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt ausgezahlt`)
};

const ja_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払い総額`)
};

const zh_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总计已提现`)
};

const ar_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي ما تم سحبه`)
};

const id_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Dicairkan`)
};

const it_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale Pagato`)
};

const ru_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего выплачено`)
};

const pt_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Sacado`)
};

const ko_total_paid_out = /** @type {(inputs: Total_Paid_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 정산 완료 금액`)
};

/**
* | output |
* | --- |
* | "Total Paid Out" |
*
* @param {Total_Paid_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const total_paid_out = /** @type {((inputs?: Total_Paid_OutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_Paid_OutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_total_paid_out(inputs)
	if (locale === "es") return es_total_paid_out(inputs)
	if (locale === "fr") return fr_total_paid_out(inputs)
	if (locale === "de") return de_total_paid_out(inputs)
	if (locale === "ja") return ja_total_paid_out(inputs)
	if (locale === "zh") return zh_total_paid_out(inputs)
	if (locale === "ar") return ar_total_paid_out(inputs)
	if (locale === "id") return id_total_paid_out(inputs)
	if (locale === "it") return it_total_paid_out(inputs)
	if (locale === "ru") return ru_total_paid_out(inputs)
	if (locale === "pt") return pt_total_paid_out(inputs)
	return ko_total_paid_out(inputs)
});